import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../utils/Loader";
import { userManualDownloadUrl, disclaimer } from '../utils/constants';
import Modal from "react-modal";
import StepHeader from '../screens/registration/stepHeader'
import { useLocation } from 'react-router-dom'
import NetworkStatusIndicator from './NetworkStatusIndicator';
Modal.setAppElement("#root");


// {head,subHeader}
const ExhibitionHeader = ({ isSteper }) => {

  const history = useNavigate();
  const [isLoading, setLoader] = useState(false);
  const marqueeRef = useRef(null);

  const loadScripts = () => {
    // This array contains all the files/CDNs 
    // const dynamicScripts = [
    //   'js/jquery.sticky.js',
    //   'js/metisMenu.min.js',
    //   'js/metisMenu-active.js',
    //   'js/main.js',
    //   'js/azia.js'
    // ];

    // for (let i = 0; i < dynamicScripts.length; i++) {
    //   const node = document.createElement('script');
    //   node.src = dynamicScripts[i];
    //   node.type = 'text/javascript';
    //   node.async = false;
    //   document.getElementsByTagName('head')[0].appendChild(node);
    // }
  }

  useEffect(() => {
    loadScripts();

  }, []);



  const onLogoutClick = () => {
    localStorage.clear();
    // history.push('/login');
  }

  const openPdf = () => {
    var URL = userManualDownloadUrl /* http://0.0.0.0:8000/ or http://127.0.0.1:8000/; */
    window.open(URL, null);
  }

  return (
    <>
      <style>
        {`
          @media (min-width: 768px) {
            .desktop-ml-100 {
              margin-left: 100px !important;
            }
          }
        `}
      </style>
      {isLoading ? (
        <Loader></Loader>
      ) : (
        null
      )}
      {/* app-Header */}

      <div className="app-header header sticky">
        <div className="container-fluid main-container d-flex align-items-center justify-content-between flex-wrap py-2 desktop-ml-100">
          <div className="d-flex align-items-center">
            <div className="side-header top-logo-almnt d-flex align-items-center justify-content-center" style={{ padding: '0', margin: '0' }}>
              <a className="header-brand1" >
                <img src="../images/itme-right-logo.png" className="header-brand-img m-0" alt="top-left logo" style={{ height: '60px' }} />
              </a>
            </div>
            <h5 className="mb-0 header-logo-name text-white d-none d-lg-block" style={{ fontSize: '15px', marginLeft: '4rem' }}>
              INDIA ITME SOCIETY<br /> Trusted name for Quality and Commitment
            </h5>
          </div>
          <div className="mt-2 mt-md-0 text-md-end text-start me-4 d-flex align-items-center gap-2 ms-auto">
            {/* Network Connectivity */}
            <NetworkStatusIndicator />

            {useLocation().pathname != '/' &&
              <a
                href='https://corporate.india-itme.com'
                target='_blank'
                rel="noopener noreferrer"
                className="btn btn-sm btn-outline-light rounded-pill"
                style={{ fontWeight: '500', padding: '5px 15px' }}
              >
                Corporate Site
              </a>
            }
          </div>
        </div>

        {/* Absolute Marquee at the bottom of the header */}
        <div className="marquee-text" style={{ position: 'absolute', bottom: '0px', left: '0', width: '100%', pointerEvents: 'none', margin: '0' }}>
          <marquee
            behavior="scroll"
            direction="left"
            scrollamount="5"
            ref={marqueeRef}
            onMouseOver={() => marqueeRef.current?.stop()}
            onMouseOut={() => marqueeRef.current?.start()}
            style={{ pointerEvents: 'auto', marginBottom: '0' }}
          >
            <b>Disclaimer and Ownership:</b> {disclaimer}
          </marquee>
        </div>

        {isSteper ? (
          // <div className="row ">
          //   <div className="step-namev2">
          //     <p>Choose your Exhibition</p>
          //   </div>
          // </div>


          <div className="breadcrumb-for-access" style={{ left: "0px", marginTop: "72px !important", zIndex: "999" }}>
            <h6 className="mb-0 py-2 text-white px-3">Choose your Exhibition</h6>
          </div>

        ) : (null)}


      </div>
      {/* /app-Header */}
    </>
  );
}
export default ExhibitionHeader;

